import { render, staticRenderFns } from "./insurances.vue?vue&type=template&id=639a3db4&"
import script from "./insurances.vue?vue&type=script&lang=js&"
export * from "./insurances.vue?vue&type=script&lang=js&"
import style0 from "./insurances.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports